<ng-container *transloco="let t;">
    <div class="content-wrapper  position-relative p-0">
        <form class="edit-playbook-form card p-2" #form="ngForm" [formGroup]="playbookForm" (ngSubmit)="onSubmit()">

            <!--        name-->

            <div class="row">
                <div class="col-12">
                    <div class="form-group">
                        <label class="form-label" for="name">{{t('Playbook name field label (edit playbook) - Playbook name')}}</label>
                        <input
                                type="text"
                                formControlName="name"
                                class="form-control"
                                [ngClass]="{ 'is-invalid': submitted && playbookForm.get('name').errors }"
                                [placeholder]="t('Playbook name field label (edit playbook) - Playbook name')"
                                aria-describedby="Playbook name"
                                autofocus=""
                                tabindex="1"
                        />

                        <ng-container
                                *ngTemplateOutlet="errorMessage; context: {
                                                                  submitted: submitted,
                                                                  formControl: playbookForm.get('name'),
                                                                  label:t('Playbook name field label (edit playbook) - Playbook name')
                                                             }"
                        ></ng-container>

                    </div>
                </div>
            </div>
            <!--        category-->
            <div class="row">
                <div class="col-12">
                    <div class="form-group">
                        <label class="form-label" for="category">{{t('Category field label (edit playbook) - Playbook Category')}}</label>
                        <ng-select [items]="categories$ | async"
                                   bindValue="id"
                                   bindLabel="name"
                                   formControlName="category"
                                   [ngClass]="{ 'is-invalid error': submitted && playbookForm.get('category').invalid }"
                                   [placeholder]="t('Category field label (edit playbook) - Playbook Category')"
                                   [addTag]="true"
                                   [addTagText]="t('Add button text (add button) - add')"
                                   (change) ="onCategorySelectionChanged($event)">
                            <ng-template ng-header-tmp>
                                <input class="form-control w-100" type="text" (input)="searchCategory($event.target.value)" />
                            </ng-template>
                        </ng-select>

                        <ng-container
                                *ngTemplateOutlet="errorMessage; context: {
                                                                  submitted: submitted,
                                                                  formControl: playbookForm.get('category'),
                                                                  label:t('Category field label (edit playbook) - Playbook Category')
                                                             }"
                        ></ng-container>

                    </div>
                </div>
            </div>

            <div class="row">
                <div class="col-12">
                    <div class="form-group">
                        <label class="form-label" for="purpose">{{t('Purpose field label (edit playbook) - Purpose')}}</label>
                        <textarea
                                formControlName="purpose"
                                class="form-control"
                                rows="3"
                                [placeholder]="t('Purpose field label (edit playbook) - Purpose')"
                                aria-describedby="Purpose"
                        ></textarea>
                    </div>
                </div>
            </div>

            <!--        usage -->
            <div class="row">
                <div class="col-12">
                    <div class="form-group">
                        <label class="form-label" for="usage">{{t('Usage field label (edit playbook) - Usage')}}</label>
                        <textarea
                                formControlName="usage"
                                class="form-control"
                                rows="3"
                                [placeholder]="t('Usage field label (edit playbook) - Usage')"
                        ></textarea>
                    </div>
                </div>
            </div>

            <!--    status &    color -->
            <div class="row">
                <div class="col-6">
                    <label class="form-label">{{ t('Status label (edit playbook) - Status') }}</label>
                    <div class="form-group mb-0 status-switch-wrapper">
                        <div class="row">
                            <div class="col-12">
                                <div class="custom-control custom-switch mb-0">
                                    <input type="checkbox" class="custom-control-input" formControlName="status" id="status" />
                                    <label class="custom-control-label" for="status">{{ t('Published status label (edit playbook) - Published') }}</label>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>


            <div class="d-flex mt-2">
                <button [disabled]="(processing$ | async)" type="submit" class="btn btn-primary me-50" rippleEffect><span *ngIf="(submitting$ | async) === true" class="spinner-border spinner-border-sm me-1"></span> {{t(this.submitButtonTranslationKey)}}</button>
                <button [disabled]="(processing$ | async)" type="reset" class="btn btn-outline-secondary" (click)="closeSiderBar()" rippleEffect>{{t("Cancel button (bulk upload) - Cancel")}}</button>
            </div>
        </form>
    </div>
</ng-container>



<ng-template #errorMessage let-formControl="formControl" let-label="label" let-submitted="submitted">
    <ng-container *transloco="let t;">
        <div *ngIf="submitted && formControl?.invalid" class="invalid-feedback" [ngClass]="{ 'is-invalid': formControl?.invalid }">
            <div *ngIf="formControl.hasError('required')">{{ t('Field required (form validation) - Field name is required', {
                fieldName: label
            }) }}</div>

            <div *ngIf="formControl.hasError('minlength')">
                {{ t('Minimal length (validation message) Minimal length is', {min: formControl.getError('minlength')?.requiredLength}) }}
            </div>
        </div>
    </ng-container>
</ng-template>

